import { render, staticRenderFns } from "./GlobaSearchBar.vue?vue&type=template&id=ce2ea1ba&scoped=true&"
import script from "./GlobaSearchBar.vue?vue&type=script&lang=js&"
export * from "./GlobaSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./GlobaSearchBar.vue?vue&type=style&index=0&id=ce2ea1ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2ea1ba",
  null
  
)

export default component.exports